
import {
    CONFIRMED_GET_IMPORTANT_QUESTIONS,
  } from "../actions/ImportantQuestionType"; 
  
  import {
    getImportantQuestions,
  } from "../../services/ImportantQuestionService"; 
  
  import swal from "sweetalert";
import { showErrorAlert } from "../../services/ErrorHandlingService";
  

  function getAuthToken(getState) {
    const stateToken = getState().auth?.authKey;
    if (stateToken) return stateToken;
  
    const storedUser = localStorage.getItem('userDetails');
    return storedUser ? JSON.parse(storedUser).token : null;
  }
  


// const flattenQuestionAnswers = (questions = []) => {
//     const result = [];
  
//     questions.forEach((item) => {
//       if (item.isGroup === "Yes" && Array.isArray(item.questions)) {
//         item.questions.forEach((q) => {
//           result.push({
//             question_answer_id: q.question_answer_id,
//             patient_id: q.patient_id,
//             form_id: q.form_id,
//             question_id: q.question_id,
//             question: q.question || "No question text",
//             answer: q.answer || "",
//             note_description: q.note_description,
//             is_important: q.is_important,
//             group_id: q.group_id || item.group_id,
//             group_name: item.group_name || "Untitled Group",
//             note_add: q.note_add,
//             created_at: q.created_at,
//             updated_at: q.updated_at,
//             isGroup: "No",
//             tags: q.tags || [],
//           });
//         });
//       } else {
//         result.push({
//           ...item,
//           question: item.question || "No question text",
//           group_name: item.group_name || "",
//           isGroup: "No",
//         });
//       }
//     });
  
//     return result;
//   };
const flattenQuestionAnswers = (questions = []) => {
  const result = []

  questions.forEach((item) => {
    // First add the group itself with isGroup="Yes" to preserve group properties
    if (item.isGroup === "Yes") {
      result.push({
        group_id: item.group_id,
        group_name: item.group_name || "Untitled Group",
        make_as_tab: item.make_as_tab || "No",
        isGroup: "Yes",
      })

      if (Array.isArray(item.questions)) {
        item.questions.forEach((q) => {
          result.push({
            question_answer_id: q.question_answer_id,
            patient_id: q.patient_id,
            form_id: q.form_id,
            question_id: q.question_id,
            question: q.question || "No question text",
            answer: q.answer || "",
            note_description: q.note_description,
            is_important: q.is_important,
            group_id: item.group_id,
            group_name: item.group_name || "Untitled Group",
            make_as_tab: item.make_as_tab || "No", // Preserve make_as_tab property
            note_add: q.note_add,
            created_at: q.created_at,
            updated_at: q.updated_at,
            isGroup: "No",
            tags: q.tags || [],
            options: q.options || [], // Include options
            validations: q.validations || [], // Include validations
          })
        })
      }
    } else {
      result.push({
        ...item,
        question: item.question || "No question text",
        group_name: item.group_name || "",
        isGroup: "No",
      })
    }
  })

  return result
}
;
 

export function getImportantQuestionsAction( patient_id , is_important) {
    return async (dispatch, getState) => {
      try {
        const token = getAuthToken(getState);
        const response = await getImportantQuestions( patient_id, is_important);
        console.log("API Important Questions Response:", response);
  
        if (response?.data?.status === "success") {
          const data = response.data.data;
          
  
          const flattenedQuestions = flattenQuestionAnswers(data);
        
          console.log("Flattened Important Questions:", flattenedQuestions);
  
          dispatch({
            type: CONFIRMED_GET_IMPORTANT_QUESTIONS,
            payload: flattenedQuestions
          });
        } else {
          showErrorAlert("Failed to get patient details");
        }
      } catch (error) {
        console.error("API Error:", error);
        showErrorAlert(error.message || "Failed to get patient details");
      }
    };
  }
  
  